module.exports = __webpack_public_path__ + "img/15cheops.a58aa2a5.svg";